// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AS9mz","type":"styles_type__10K14","choices":"styles_choices__aaPLg"};